import type { SupremeAffixCollectionType } from '@/types/equip'
import type { ItemType } from '@/types/item'
import type { UserAttrType } from '@/types/user'
import { formatNumber } from '@/utils'
import { noPercentEquipAttrKeyList } from '@/views/item/data'

export let supremeBasicFactor: Partial<UserAttrType> = {}
export function setSupremeBasicFactor(data: Partial<UserAttrType>) {
  supremeBasicFactor = data
}
export let supremeAffixCollection: SupremeAffixCollectionType = {}
export function setSupremeAffixCollection(data: SupremeAffixCollectionType) {
  supremeAffixCollection = data
}

export function getSupremeBasicAttrValue(key: keyof UserAttrType, value: number) {
  // @ts-ignore
  const res = supremeBasicFactor[key]! * value * 1.5
  if (key === 'cda' || key === 'sce') return formatNumber(res, 2)
  else if (noPercentEquipAttrKeyList.includes(key)) return Math.round(res)
  else return formatNumber(res, 2)
}

const refineHitFactor: Record<number, number> = {
  0: 1,
  1: 1.3,
  2: 1.8,
  3: 2.4,
}
export function getSupremeAffixBasicAttrValue(key: keyof UserAttrType, value: number, refineHitCount: number) {
  const res = value * refineHitFactor[refineHitCount]
  if (noPercentEquipAttrKeyList.includes(key)) return Math.round(res)
  else return formatNumber(res, 2)
}
export function getSupremeRealAffixList(
  supremeAttrs: ItemType['supremeAttrs'],
  supremeEngraveAttr: ItemType['supremeEngraveAttr'],
  supremeReforgeAttr?: ItemType['supremeReforgeAttr'],
) {
  const affixList = [...(supremeAttrs?.affixList || [])]
  if (supremeEngraveAttr?.affixKey) affixList.push(supremeEngraveAttr.affixKey)
  if (supremeReforgeAttr && affixList[supremeReforgeAttr.affixIndex] !== undefined) {
    affixList[supremeReforgeAttr.affixIndex] = supremeReforgeAttr.affixKey
  }
  return affixList
}

export const engraveSupremeMaxQulityMap: Record<number, string> = {
  1: 'race',
  2: 'epic',
  3: 'epic',
  4: 'epic',
  5: 'legend',
}
